export default "__VITE_ASSET__DEsXFRSR__"